import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, TimePicker, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { addLunchHours, deleteLunchHours, getAllLunchHours, updateLunchHours } from '../../redux/rtk/features/masters/lunchHoursSlice';
import PageTitle from '../page-header/PageHeader';
dayjs.extend(utc);
dayjs.extend(timezone);
const LunchHoursMaster = () => {
    const { Title } = Typography;

    const [editingLunchHours, setEditingLunchHours] = useState(null);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { list, loading } = useSelector((state) => state.lunchHours);

    useEffect(() => {
        dispatch(getAllLunchHours());
    }, [dispatch]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();

            const formattedValues = {
                name: values.name,
                startTime: dayjs(values.startTime).utc(),
                endTime: dayjs(values.endTime).utc(),
            };
            console.log("formattedValues", formattedValues);

            if (editingLunchHours) {
                // Update existing category
                const result = await dispatch(
                    updateLunchHours({ id: editingLunchHours.id, formattedValues })
                ).unwrap();
                if (result.message === 'success') {
                    dispatch(getAllLunchHours());
                } else {
                    message.error('Error updating category!');
                }
            } else {
                // Add new category
                const result = await dispatch(addLunchHours(formattedValues)).unwrap();
                if (result.message === 'success') {
                    dispatch(getAllLunchHours());
                } else {
                    message.error('Error adding category!');
                }
            }
            form.resetFields();
            setEditingLunchHours(null);
        } catch (error) {
            console.error('Validation failed or API error:', error);
            message.error('Failed to add or update category!');
        }
    };

    // Handle deletion
    const handleDelete = async (id) => {
        try {
            const result = await dispatch(deleteLunchHours(id)).unwrap();
            if (result?.message === 'success') {
                dispatch(getAllLunchHours()); // Refresh table data
            } else {
                message.error('Error deleting category!');
            }
        } catch (error) {
            console.error('Delete API error:', error);
        }
    };

    // Table columns
    const columns = [
        {
            title: 'Break Hours',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Start Time',
            dataIndex: 'startTime',
            key: 'startTime',
            render: (startTime) => dayjs(startTime).format(" HH:mm A"),

        },
        {
            title: 'End Time',
            dataIndex: 'endTime',
            key: 'endTime',
            render: (endTime) => dayjs(endTime).format(" HH:mm A"),

        },
        {
            title: 'Actions',
            key: 'actions',
            // render: (_, record) => (
            //     <>
            //         <Button type="link" onClick={() => {
            //             setEditingLunchHours(record);
            //             form.setFieldsValue(record);
            //         }}>
            render: (_, record) => (
                <>
                    <Button type="link" onClick={() => {
                        setEditingLunchHours(record);
                        // Convert the time strings to dayjs objects
                        form.setFieldsValue({
                            ...record,
                            startTime: record.startTime ? dayjs(record.startTime) : null,
                            endTime: record.endTime ? dayjs(record.endTime) : null
                        });
                    }}>
                        Edit
                    </Button>
                    <Popconfirm
                        title="Are you sure you want to delete this category?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="link" danger>
                            Delete
                        </Button>
                    </Popconfirm>
                </>
            ),
        },
    ];

    return (
        <div>
            <PageTitle title='Back' />
            <Row gutter={16}>
                <Col span={8}>
                    <Card title={editingLunchHours ? 'Edit Break Hours' : 'Add Break Hours'}>
                        <Form
                            form={form}
                            style={{ marginBottom: "40px" }}
                            name="breakHours-form"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 14 }}
                            onFinish={handleSubmit}
                            autoComplete="off"
                        >
                            <Form.Item
                                name="name"
                                label="Break Name"
                                rules={[{ required: true, message: 'Please enter a name!' }]}
                            >
                                <Input placeholder="Enter Any Name" />
                            </Form.Item>
                            <Form.Item
                                style={{ marginBottom: "10px" }}
                                label='Start Time'
                                name='startTime'
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input break start time!",
                                    },
                                ]}>
                                <TimePicker />
                            </Form.Item>

                            <Form.Item
                                style={{ marginBottom: "20px" }}
                                label='End Time'
                                name='endTime'
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input break end time!",
                                    },
                                ]}>
                                <TimePicker />
                            </Form.Item>
                            <Button type="primary" block htmlType="submit">
                                {editingLunchHours ? 'Update Break Hours' : 'Add Break Hours'}
                            </Button>
                        </Form>
                    </Card>
                </Col>
                <Col span={16}>
                    <Card title="Break Hours">
                        <Table
                            dataSource={list}
                            columns={columns}
                            rowKey="id"
                            loading={loading}
                            style={{ marginTop: 0 }}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default LunchHoursMaster;
